import React from 'react'
import Text from "../../../../components/Text";
import Card from "../../../../components/Card";
import cx from 'classnames'
import styles from './CreateCard.module.css'

const CreateCard: React.FC<{text: string, openCreateModal: () => void}> = ({text, openCreateModal}) => {
    return (
        <Card classes={cx(styles['card-wrapper'])}>
            <div className={cx(styles['card-inner-wrapper'])} onClick={() => openCreateModal()}>
                <div className={cx(styles['card-plus'])}>
                    +
                </div>
                <Text classes={'text-center'}>{text}</Text>
            </div>
        </Card>
    )
}

export default CreateCard
